import React, { Component } from 'react';
import './Select.css';

export default class Select extends Component {
	constructor(props) {
		super(props);

		this.state = {

		}
	}

	render() {
		let select_style = {
			border: 'none',
			color: 'white',
			fontSize: 16,
			padding: 5,
			backgroundColor: window.app.state.colours.midnight_sky,
			opacity: 0.75,
			borderRadius: 10,
			height: 30,
			textAlignLast: 'center',
		}

		let arrow_style = { display: 'none' };

		select_style = Object.assign(select_style, this.props.select_style);
		arrow_style = Object.assign(arrow_style, this.props.arrow_style);

		return (
			<div id='select' style={this.props.style} className="custom-select">
				<select value={this.props.value} onChange={(e) => this.props.onSelect(e.target.value)} style={select_style} disabled={this.props.disabled}>
					{this.props.options}
				</select>
				<div className="select_arrow" style={arrow_style}>
				</div>
			</div>
		)
	}
}